import { render, staticRenderFns } from "./PCalls.vue?vue&type=template&id=6c982e26&"
import script from "./PCalls.vue?vue&type=script&lang=js&"
export * from "./PCalls.vue?vue&type=script&lang=js&"
import style0 from "./PCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports